/* eslint-disable */
import { user1Fixture } from '../User/User.service.fixture';

/* eslint-disable import/prefer-default-export */
// This rule should only be disabled whilst there is only one `export` in this file

/** @type {AuthEntity} */
export const authFixture = {
  accessToken: {
    authorizeUrl: `http://localhost:3000/authorizeUrl`,
    claims: {},
    expiresAt: Date.now() + 15 * 60 * 1000,
    roles: [],
    scopes: [`email`, `openid`, `profile`],
    token: `ABC123`,
    type: `Bearer`,
    userinfoUrl: `http://localhost:3000/userinfoUrl`,
  },
  id: `ABC123`,
  user: user1Fixture,
};
